module.exports = __webpack_public_path__ + "img/127.6.4f68a9f4.png";